/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListCustomersRequest = {
  /**
   * The page number for pagination.
   */
  pageNumber?: number | undefined;
  /**
   * The number of items per page.
   */
  pageSize?: number | undefined;
};

/** @internal */
export const ListCustomersRequest$inboundSchema: z.ZodType<
  ListCustomersRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  page_number: z.number().default(1),
  page_size: z.number().default(50),
}).transform((v) => {
  return remap$(v, {
    "page_number": "pageNumber",
    "page_size": "pageSize",
  });
});
/** @internal */
export type ListCustomersRequest$Outbound = {
  page_number: number;
  page_size: number;
};

/** @internal */
export const ListCustomersRequest$outboundSchema: z.ZodType<
  ListCustomersRequest$Outbound,
  z.ZodTypeDef,
  ListCustomersRequest
> = z.object({
  pageNumber: z.number().default(1),
  pageSize: z.number().default(50),
}).transform((v) => {
  return remap$(v, {
    pageNumber: "page_number",
    pageSize: "page_size",
  });
});

export function listCustomersRequestToJSON(
  listCustomersRequest: ListCustomersRequest,
): string {
  return JSON.stringify(
    ListCustomersRequest$outboundSchema.parse(listCustomersRequest),
  );
}
export function listCustomersRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListCustomersRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListCustomersRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListCustomersRequest' from JSON`,
  );
}
